var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input-field d-flex"},[_c('div',{staticClass:"div-icon"},[_c('em',{class:'icon ' + _vm.icon})]),_c('input',{class:_vm.className,attrs:{"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.value}})])
}
var staticRenderFns = []

export { render, staticRenderFns }